<ul class="mt-2 w-100 list-group">
    <li class="list-group-item subheader d-block align-items-center">
        <div class="d-flex align-items-center">
            <label class="form-check-label" for="flexCheckDefault"
                translate="Settings.AccountWorkgroupsSection.Workgroups"></label>
        </div>
    </li>


    <li class="list-group-item d-block nohover align-items-center" *ngIf="!workgroups || workgroups.length == 0"
        translate="Settings.AccountWorkgroupsSection.NoAssignedWorkgroups">
        <app-info-button labelName="Settings.AccountWorkgroupsSection.AddWorkgroupsTooltip">
        </app-info-button>
    </li>
    <li class="list-group-item d-block nohover align-items-center"
        [ngClass]="{ 'list-group-item-disabled': isOnlyCustomer}" *ngFor="let workgroup of workgroups; let i = index;">
        <app-userWorkgroupListItem [userWorkgroup]="workgroup" [isOnlyCustomer]="isOnlyCustomer"
            (removeWorkgroupFromUser)="removeWorkgroup($event)"></app-userWorkgroupListItem>
    </li>
</ul>